import { createStore, derive } from 'store-utils';
import { Nullable } from 'common-types';
import { ScanHistory } from '../scan-history-types';
import { ChartDataset } from 'chart.js';

const baseStore = createStore<OrgSettingsStoreState>(
  {
    timeExecutionData: null,
    timeFinalizingData: null,
    timeoutsData: null,
    categoryBreakdownData: null,
    labels: null,
    selectedScanId: null,
    scanInfo: null,
    totalTime: null,
    errorsData: null,
  },
  'Scan History Store',
);

const ScanHistoryStore = derive(
  {
    selectedScanInfo: get => {
      const { selectedScanId, scanInfo } = get(baseStore);
      if (selectedScanId) {
        return scanInfo?.find(s => s.scanId === selectedScanId);
      }
    },
  },
  { proxy: baseStore },
);

interface OrgSettingsStoreState {
  timeExecutionData: Nullable<ChartDataset<'line', number[]>[]>;
  categoryBreakdownData: Nullable<ChartDataset<'line', number[]>[]>;
  labels: Nullable<{ scanId: string; scanDate: string }[]>;
  timeFinalizingData: Nullable<ChartDataset<'line', number[]>[]>;
  timeoutsData: Nullable<ChartDataset<'line', number[]>[]>;
  selectedScanId: Nullable<string>;
  scanInfo: Nullable<ScanHistory[]>;
  totalTime: Nullable<ChartDataset<'line', number[]>[]>;
  errorsData: Nullable<ChartDataset<'line', number[]>[]>;
}

export default ScanHistoryStore;
